export const TEASER_TOPICS = [
  { id: "power", title: "Power", body: "From the grid connection to the rack: how megawatts reach the servers and stay on.", art: "radarSweep" },
  { id: "cooling", title: "Cooling", body: "Air, liquid and immersion, and why AI-density racks rewrote the rules.", art: "thermalContours" },
  { id: "connectivity", title: "Connectivity", body: "Fiber, subsea cables and the networks that tie campuses together.", art: "lightFiber" },
  { id: "ai-infrastructure", title: "AI Infrastructure", body: "GPUs, high-density halls and what makes a site truly AI-ready.", art: "siliconDie" },
  { id: "development", title: "Development", body: "Land, power, permits and the responsible growth behind every campus.", art: "blueprintSpec" },
  { id: "careers", title: "Careers", body: "The roles that build and run the industry, and how to step into one.", art: "neuralGlobe" },
];

export const TEASER_AUDIENCES = [
  { id: "new", title: "New to the Industry", body: "Students, career changers and curious minds who want the big picture in plain language." },
  { id: "build", title: "Build & Operate", body: "Technicians, engineers and operators going deeper on critical systems." },
  { id: "business", title: "The Business Side", body: "Sales, finance, real estate and partnership teams who need to speak the language." },
  { id: "teams", title: "Companies & Teams", body: "Employers onboarding new hires, interns and commercial teams with a shared foundation." },
];

export const BUILD_STATUS = [
  { id: "lesson", label: "Intro lesson: Inside a Data Center", state: "Built", filled: 10 },
  { id: "programs", label: "Six learning programs", state: "In development", filled: 6 },
  { id: "teams", label: "Team training pilots", state: "Planning", filled: 3 },
];
